import { createApi } from '@reduxjs/toolkit/query/react'
import {baseQuery} from "../baseQuery";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const settingsApi = createApi({
    reducerPath: 'settingsApi',
    baseQuery,
    tagTypes: ["Settings"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        getAllSettings: builder.query({
            query: () => ({ url: `/users/settings` }),
            providesTags:["Settings"]
        }),
        getSingleSetting: builder.query({
            query: ({slug}) => ({ url: `/users/settings/${slug}` }),
            providesTags:["Settings"]
        }),
        updateSetting: builder.mutation({
            query: ({slug, ...body}) => ({
                url: `/users/settings/${slug}`,
                method: 'PUT',
                body
            }),
            invalidatesTags: ["Settings"]
        })
    }),
})

export const {
    useLazyGetAllSettingsQuery,
    useLazyGetSingleSettingQuery,
    useUpdateSettingMutation
} = settingsApi
